import { Button, Card } from "antd";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import DynamicIcon from "../DynamicIcon";
import { useClickOutside } from "../../hooks/useClickOutside";
import { CloseCircleOutlined } from "@ant-design/icons";

export const ItemRender = ({ item }) => {
  const wrapperRef = useRef(null);

  const [isHover, setIsHover] = useState(false);
  const [contractItems, setContractItems] = useState([]);

  const handleClick = (e) => {
    if (item.isGroup) {
      e.preventDefault();
      setContractItems(item.children);
    }
  };

  useClickOutside(
    wrapperRef,
    () => setContractItems([]),
    contractItems.length > 0,
  );

  return (
    <a
      ref={wrapperRef}
      href={item.href}
      onClick={handleClick}
      className="item-contract"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      {item["color-icon"] ? (
        <Card
          style={{
            background: isHover ? item["color-icon"] : item.bg,
            border: "none",
            borderRadius: 25,
            padding: 10,
          }}
        >
          <div
            style={{
              textAlign: "center",
              color: isHover ? item.bg : item["color-icon"],
              fontSize: 18,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            <DynamicIcon component={item.icon} type={item.type} />
            <br />
            <span style={{ whiteSpace: "nowrap" }} className="textHover">
              &nbsp;{item.name}
            </span>
          </div>
        </Card>
      ) : (
        <Card
          style={{
            background: isHover ? "#fff" : item.bg,
            border: "none",
            borderRadius: 25,
            padding: 10,
            position: "relative",
          }}
        >
          {item.isGroup && contractItems.length > 0 ? (
            <div className="item-contract-group">
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  setContractItems([]);
                }}
                type="text"
                shape="circle"
                className="item-contract-group-close"
              >
                <CloseCircleOutlined />
              </Button>

              <div className="item-contract-group-title">Quản lý chứng từ</div>

              <div className="item-contract-group-content">
                {contractItems.map((item) => (
                  <a
                    href={item.href}
                    key={item}
                    onClick={(e) => e.stopPropagation()}
                    className="item-contract-group-item"
                  >
                    <DynamicIcon
                      size={20}
                      component={item.icon}
                      type={item.type}
                    />
                    <span className="item-contract-group-item-text">
                      &nbsp;{item.name}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          ) : null}
          <div
            style={{
              textAlign: "center",
              color: isHover ? item.bg : "#fff",
              fontSize: 18,
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
          >
            <DynamicIcon component={item.icon} type={item.type} />
            <br />
            <span style={{ whiteSpace: "nowrap" }} className="textHover">
              &nbsp;{item.name}
            </span>
          </div>
        </Card>
      )}
    </a>
  );
};

ItemRender.propTypes = {
  item: PropTypes.object.isRequired,
};
